import api from './api';

export const notificationService = {
  // 🔹 Atualiza o token de push do Expo
  updateExpoPushToken: async (userId, expoToken) => {
    try {
      const response = await api.post('/update-expo-push-token/', {
        user: userId,
        token: expoToken,
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar Expo Push Token:', error);
      throw error;
    }
  },

  // 🔹 Envia uma notificação
  sendNotification: async (userId, notificationId) => {
    try {
      const response = await api.post('/send-notification/', {
        user: userId,
        notification_id: notificationId,
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao enviar notificação:', error);
      throw error;
    }
  },
};
